import {endsWith} from 'lodash';
import {FILE_SEPARATOR} from 'redux/server/hooks/useBrowseList';
import {IVFSNode, VFSNodeDiplomats} from 'types/diplomat/sftp/VFSNode';

export const castVfsNodes = (paths: IVFSNode[], parentPath: string) => {
   const nodes = VFSNodeDiplomats.cast(paths);

   const sep = endsWith(parentPath, FILE_SEPARATOR) ? '' : FILE_SEPARATOR;
   nodes.forEach((n) => {
      n._originPath = n.path;
      const path = parentPath + sep + n.name;
      n.path = path;
      n.id = path;
      n.folderId = parentPath;
   });
   //    nodes.forEach((n) => {
   //       n.parentId = parentPath;
   //       n.folderId = parentPath;
   //    });

   return nodes;
};
